<template>
  <div class="Tab">
    <el-tabs v-model="Tab.select"
             @tab-click="Tab.handle">
      <el-tab-pane v-for="(item,index) in Tab.pages"
                   :key="index+'_tab'"
                   :label="item.name"
                   :name="item.id"></el-tab-pane>
    </el-tabs>

  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';

export default {
  // import引入的组件需要注入到对象中才能使用
  components: {},
  props: {
    Tab: Object
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created () {

  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted () {

  },
  beforeCreate () { }, // 生命周期 - 创建之前
  beforeMount () { }, // 生命周期 - 挂载之前
  beforeUpdate () { }, // 生命周期 - 更新之前
  updated () { }, // 生命周期 - 更新之后
  beforeDestroy () { }, // 生命周期 - 销毁之前
  destroyed () { }, // 生命周期 - 销毁完成
  activated () { } // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang='scss' scoped>
//@import url(); 引入公共css类
.Tab {
  background-color: #fff;
  border-radius: 10px;
  padding: 15px 30px;
  margin: 20px;
  ::v-deep .el-tabs__nav-wrap::after {
    height: auto;
  }
}
</style>
